module.exports = __webpack_public_path__ + "static/img/202213.0603ca2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/202213.jpg
// module id = HwQ0
// module chunks = 0